// Quicklook-Modal für Anhänge (Bild, PDF, Audio). Esc oder Klick daneben schließt, ⤓ lädt herunter.
import { useEffect } from 'react';
import { bytes } from '../lib/format.ts';
import { schliesseVorschau, useVorschau, vorschauArt } from '../lib/vorschau.ts';

export function AnhangVorschau() {
  const a = useVorschau();
  useEffect(() => {
    if (!a) return;
    const h = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        schliesseVorschau();
      }
    };
    window.addEventListener('keydown', h, true);
    return () => window.removeEventListener('keydown', h, true);
  }, [a]);
  if (!a) return null;
  const art = vorschauArt(a);
  const url = `/api/attachments/${a.id}`;
  return (
    <div className="ql-bg" onClick={schliesseVorschau} role="dialog" aria-label={a.filename}>
      <div className={`ql ql-${art ?? 'datei'}`} onClick={(e) => e.stopPropagation()}>
        <div className="ql-h">
          <span className="ql-name" title={a.filename}>
            {a.filename}
          </span>
          <span className="muted">{bytes(a.size)}</span>
          <a className="btn sm" href={`${url}?download=1`} title="Herunterladen">
            ⤓ Laden
          </a>
          <button className="btn sm ghost" onClick={schliesseVorschau} aria-label="Schließen">
            ✕
          </button>
        </div>
        <div className="ql-body">
          {art === 'bild' && <img src={url} alt={a.filename} />}
          {art === 'pdf' && <iframe src={url} title={a.filename} />}
          {art === 'audio' && <audio src={url} controls autoPlay />}
          {!art && (
            <p className="muted">
              Keine Vorschau für diesen Dateityp. <a href={`${url}?download=1`}>Herunterladen</a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
